(function () {
  var config = Object.assign({
    defaultMode: "navy",
    param: "tk9_cta_color",
    storageKey: "tk9_commerce_cta_color"
  }, window.TeamK9CommerceCTAColorConfig || {});

  function normalizeMode(value) {
    return String(value || "").toLowerCase() === "legacy" ? "legacy" : "navy";
  }

  function storedMode() {
    try {
      return window.localStorage.getItem(config.storageKey);
    } catch (error) {
      return null;
    }
  }

  function persistMode(mode) {
    try {
      window.localStorage.setItem(config.storageKey, normalizeMode(mode));
    } catch (error) {}
  }

  function applyMode(mode) {
    var nextMode = normalizeMode(mode || config.defaultMode);
    document.documentElement.setAttribute("data-tk9-commerce-cta-color", nextMode);
    return nextMode;
  }

  function isHeaderLocalizationControl(node) {
    if (!node || !node.matches || !node.closest("header-component, .header, header")) return false;
    if (node.matches('button[name="add"], [name="checkout"], .product-form__submit, .add-to-cart-button, .cart__checkout-button')) return false;

    var haystack = [
      node.className || "",
      node.id || "",
      node.name || "",
      node.getAttribute("aria-label") || "",
      node.getAttribute("aria-controls") || "",
      node.getAttribute("data-testid") || "",
      node.textContent || ""
    ].join(" ");

    if (/country|currency|locali[sz]ation|locale|region|market/i.test(haystack)) return true;
    if (/\b(USD|CAD|AUD|NZD|GBP|EUR|JPY|MXN)\b/.test(haystack)) return true;
    return !!node.querySelector('[class*="flag" i], img[alt*="flag" i], svg[aria-label*="flag" i]');
  }

  function markHeaderLocalizationControls(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var selector = 'header-component .button, header-component button, .header .button, .header button, header .button, header button';
    var nodes = [];

    if (scope.matches && scope.matches(selector)) nodes.push(scope);
    scope.querySelectorAll(selector).forEach(function (node) {
      nodes.push(node);
    });

    nodes.forEach(function (node) {
      if (isHeaderLocalizationControl(node)) {
        node.setAttribute("data-tk9-localization-control", "true");
      }
    });
  }

  function initHeaderLocalizationControlMarkers() {
    markHeaderLocalizationControls(document);

    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        markHeaderLocalizationControls(document);
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      observer.disconnect();
    }, 20000);
  }

  function requestedMode() {
    try {
      var params = new URLSearchParams(window.location.search);
      var value = params.get(config.param);
      if (value === "legacy" || value === "navy") {
        persistMode(value);
        return value;
      }
    } catch (error) {}
    return storedMode() || config.defaultMode;
  }

  window.TeamK9CommerceCTAColor = {
    mode: function () {
      return document.documentElement.getAttribute("data-tk9-commerce-cta-color") || normalizeMode(requestedMode());
    },
    useLegacy: function () {
      persistMode("legacy");
      return applyMode("legacy");
    },
    useNavy: function () {
      persistMode("navy");
      return applyMode("navy");
    },
    reset: function () {
      try {
        window.localStorage.removeItem(config.storageKey);
      } catch (error) {}
      return applyMode(config.defaultMode);
    }
  };

  applyMode(requestedMode());
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHeaderLocalizationControlMarkers, { once: true });
  } else {
    initHeaderLocalizationControlMarkers();
  }
})();
